import React from "react";
import { ReportNotesSection } from "../../report/ReportNotesSection";
import { ReportPrintFooter } from "../../report/ReportPrintFooter";
import { ReportRule } from "../../report/ReportRule";
import { PayrollReportEmployeeSection } from "./PayrollReportEmployeeSection";
import { PayrollReportOverallSummarySection } from "./PayrollReportOverallSummarySection";
import "../../report/ReportPrintDocument.css";
import "./PayrollReportPrintDocument.css";

export function PayrollReportPrintDocument({ reportModel }) {
  if (!reportModel) return null;

  if (reportModel.isGrouped) {
    const { sections, notes, header } = reportModel;

    return (
      <article
        className="payroll-report-print-document report-print-document"
        aria-label="Payroll Report — Print"
      >
        {sections.map((section, index) => (
          <React.Fragment key={section.header?.employeeName || index}>
            {index > 0 && (
              <div className="payroll-report-employee-section__break">
                <ReportRule />
              </div>
            )}
            <PayrollReportEmployeeSection
              sectionModel={section}
              variant="print"
              className={index > 0 ? "payroll-report-employee-section--continued" : ""}
            />
          </React.Fragment>
        ))}

        <PayrollReportOverallSummarySection
          reportModel={reportModel}
          variant="print"
        />

        {notes && <ReportNotesSection notes={notes} variant="print" />}

        <ReportPrintFooter generatedDate={header.generatedDate} />
      </article>
    );
  }

  const { header, notes } = reportModel;

  return (
    <article
      className="payroll-report-print-document report-print-document"
      aria-label="Payroll Report — Print"
    >
      <PayrollReportEmployeeSection sectionModel={reportModel} variant="print" />

      {notes && <ReportNotesSection notes={notes} variant="print" />}

      <ReportPrintFooter generatedDate={header.generatedDate} />
    </article>
  );
}
